/* eslint-disable */

import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import ActivateDomain from '../../../ActivateDomain/Domain';
import DataBackfill from '../../../../modules/DataBackfill';
import { withTranslation } from 'react-i18next';
import ActivatePlanComponent from '../../../ActivatePlanComponent';

class Domains extends Component {
    constructor() {
        super();

        this.domains = window.settings_domains;
        this.is_viewer = !window.is_not_viewer;
        this.active_domains = window.active_domains ?? [];
        this.domains_with_permission_error = window.domains_with_permission_error ?? [];

        this.is_superuser = isTrue(window.is_superuser);

        this.getPermissions = this.getPermissions.bind(this);

        // Entitlements are seeded from localStorage and then refreshed by the
        // /api/v1/entitlements/ call in base-sidebar.html, which fires
        // getPermissionsEvent when it lands.
        this.state = {
            user_permissions: window.user_permissions ? { ...window.user_permissions } : {},
        };
    }

    componentDidMount() {
        document.addEventListener('getPermissionsEvent', this.getPermissions);
    }

    componentWillUnmount() {
        document.removeEventListener('getPermissionsEvent', this.getPermissions);
    }

    getPermissions() {
        this.setState({
            user_permissions: window.user_permissions ? { ...window.user_permissions } : {},
        });
    }

    render() {
        const { t } = this.props;
        const { user_permissions } = this.state;

        // This whole card only controls Search/Discover Analytics domains, so it
        // is meaningless to a plan that includes neither product (e.g. AI
        // Tracking only).
        const hasAnalyticsProducts = Boolean(
            user_permissions?.discover_analytics || user_permissions?.search_analytics,
        );

        return (
            <div className="settings-card settings-domains">
                <div className="settings-domains-header">
                    <div>
                        <div className="d-flex">
                            {t('settings.domains.header')}
                            <div className="settings-domains-tag">
                                {this.props.active_domains_count} out of{' '}
                                {this.props.available_domains_count}
                            </div>
                        </div>
                        {!hasAnalyticsProducts && (
                            <div className="settings-domains-subtitle settings-domains-notice">
                                {t('settings.domains.no_analytics_products')}
                            </div>
                        )}
                        {this.is_viewer && (
                            <div className="settings-domains-subtitle">
                                {t('settings.domains.subheader')}
                            </div>
                        )}
                        {this.props.active && this.props.available_domains_count > 1 && (
                            <>
                                <div className="settings-domains-subtitle">
                                    {' '}
                                    {t('settings.domains.availabe_domains')}
                                </div>
                                {!this.props.active_domains_exists && (
                                    <div className="settings-domains-subtitle">
                                        {t('settings.domains.active_domains_exists')}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="d-flex gap-8">
                        {!isTrue(this.props.is_deactivated) && (
                            <>
                                {!isTrue(this.props.active) &&
                                    this.props.available_domains_count > 1 && (
                                        <ActivatePlanComponent button_name="Activate Plan Domains now" />
                                    )}
                                <a
                                    href="/domains/link"
                                    className="button button-filled button-primary"
                                >
                                    {t('settings.domains.add_domain')}
                                </a>
                            </>
                        )}{' '}
                    </div>
                </div>
                <div className="settings-domains-body">
                    {this.domains?.length > 0 &&
                        this.domains?.map((domain) => (
                            <div key={domain.id}>
                                <div className="settings-domains-body-item">
                                    {!isTrue(this.props.is_deactivated) && (
                                        <ActivateDomain
                                            domain_pk={domain.pk}
                                            active_domains={this.props.active_domains}
                                            active_domains_count={this.props.active_domains_count}
                                            active_domain={domain.active}
                                            available_domains_count={
                                                this.props.available_domains_count
                                            }
                                            domain_url={domain.url}
                                            is_viewer={this.is_viewer}
                                        />
                                    )}
                                    <div>
                                        <div className="settings-domains-body-item-text">
                                            {domain.url}
                                            {(isTrue(domain.active) ||
                                                (isTrue(this.props.is_deactivated) &&
                                                    this.active_domains.includes(domain.id))) && (
                                                <a href={`/domains/${domain.pk}/`}>
                                                    {t('settings.domains.view_report')}
                                                </a>
                                            )}
                                        </div>
                                        {this.is_superuser && (
                                            <div className="dataBackfill-container">
                                                <DataBackfill domain={domain.url} />
                                                <div style={{ fontSize: '9px', color: '#888' }}>
                                                    <strong>
                                                        {' '}
                                                        {t('settings.domains.domain')}:
                                                    </strong>{' '}
                                                    {domain.url}{' '}
                                                    <strong>
                                                        {' '}
                                                        {t('settings.domains.account')}:{' '}
                                                    </strong>{' '}
                                                    {domain.account}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        {this.is_superuser && (
                                            <a
                                                href={`/domains/${domain.pk}/update?next=/settings/`}
                                                title="Refresh (30 Days)"
                                            >
                                                {' '}
                                                <i className="icon-Frame-converted"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                                {this.domains_with_permission_error.includes(domain.url) && (
                                    <div className="permissions-errors-message">
                                        {t('settings.domains.permission_error_message', {
                                            domain: domain.url,
                                        })}
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

export default withTranslation()(Domains);
